import client from "./client";

export const getPayments = (params) =>
  client.get(`/payment/`, {
    params
  });

export const editPayment = ({
  id,
  key,
  price,
  type,
  resultCode,
  paymentNumber,
  bankCode,
  bankAccount,
  transactionDate,
  rcptTid,
  refundPrice,
  refundId,
  order,
}) =>
  client.put(`/payment/${id}/`, {
    key,
    price,
    type,
    resultCode,
    paymentNumber,
    bankCode,
    bankAccount,
    transactionDate,
    rcptTid,
    refundPrice,
    refundId,
    order,
  });

export const createRefund = ({ id, orderProductId, price }) =>
  client.post(`/refund/`, {
    id,
    orderProductId,
    price,
  });
